
export default {
  props: {
    rating: {
      type: Number,
      required: true,
    },
    color: {
      type: Boolean,
      default: true,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    title() {
      switch (Math.floor(this.rating)) {
        case 10:
        case 9:
          return 'Wonderful'

        case 8:
          return 'Very Good'

        case 7:
          return 'Good'

        case 6:
          return 'Pleasant'

        default:
          return ''
      }
    },
  },
}
